export const VALUE_REF_KG_CO2_BY_PARTICIPANT = 45;

export type CalculateFestivalEnv = {
  scoreLetter: string;
  score: number;
  maxScore: number;
  topics: {
    GLOBAL_CO2: {
      score: number;
      maxScore: number;
      sections: {
        CO2: { score: number; maxScore: number };
      };
    };
    FOOD_BEVERAGES: {
      score: number;
      maxScore: number;
      sections: {
        CATERING: { score: number; maxScore: number };
        BEVERAGES: { score: number; maxScore: number };
        DISHES: { score: number; maxScore: number };
      };
    };
    RESOURCES_POLLUTION: {
      score: number;
      maxScore: number;
      sections: {
        WATER: { score: number; maxScore: number };
        ENERGY: { score: number; maxScore: number };
        WASTE_ECODESIGN: { score: number; maxScore: number };
        POLLUTION_LOCATION: { score: number; maxScore: number };
      };
    };
    COMMUNICATION: {
      score: number;
      maxScore: number;
      sections: {
        PHYSICAL_COMMUNICATION: { score: number; maxScore: number };
        DIGITAL_COMMUNICATION: { score: number; maxScore: number };
      };
    };
    PUBLIC_ENGAGEMENT: {
      score: number;
      maxScore: number;
      sections: {
        MOBILITY_STRATEGY: { score: number; maxScore: number };
        PUBLIC_INFORMATION: { score: number; maxScore: number };
      };
    };
  };
  sectors: {
    ANY: { score: number; maxScore: number };
    ARTISTS: { score: number; maxScore: number };
    PUBLIC: { score: number; maxScore: number };
    SITE: { score: number; maxScore: number };
    TEAM: { score: number; maxScore: number };
  };
};

export const EMPTY_CALCULATE_FESTIVAL_ENV: CalculateFestivalEnv = {
  scoreLetter: '-',
  score: 0,
  maxScore: 0,
  topics: {
    GLOBAL_CO2: {
      score: 0,
      maxScore: 0,
      sections: {
        CO2: { score: 0, maxScore: 0 },
      },
    },
    FOOD_BEVERAGES: {
      score: 0,
      maxScore: 0,
      sections: {
        CATERING: { score: 0, maxScore: 0 },
        BEVERAGES: { score: 0, maxScore: 0 },
        DISHES: { score: 0, maxScore: 0 },
      },
    },
    RESOURCES_POLLUTION: {
      score: 0,
      maxScore: 0,
      sections: {
        WATER: { score: 0, maxScore: 0 },
        ENERGY: { score: 0, maxScore: 0 },
        WASTE_ECODESIGN: { score: 0, maxScore: 0 },
        POLLUTION_LOCATION: { score: 0, maxScore: 0 },
      },
    },
    COMMUNICATION: {
      score: 0,
      maxScore: 0,
      sections: {
        PHYSICAL_COMMUNICATION: { score: 0, maxScore: 0 },
        DIGITAL_COMMUNICATION: { score: 0, maxScore: 0 },
      },
    },
    PUBLIC_ENGAGEMENT: {
      score: 0,
      maxScore: 0,
      sections: {
        MOBILITY_STRATEGY: { score: 0, maxScore: 0 },
        PUBLIC_INFORMATION: { score: 0, maxScore: 0 },
      },
    },
  },
  sectors: {
    ANY: { score: 0, maxScore: 0 },
    ARTISTS: { score: 0, maxScore: 0 },
    PUBLIC: { score: 0, maxScore: 0 },
    SITE: { score: 0, maxScore: 0 },
    TEAM: { score: 0, maxScore: 0 },
  },
};
